import { actPhrase } from './messageCatalog'

// CloseNowMode (03-dominio.md, RN22-RN24, story 211): whether the panel works in «close now» mode and what that means for the
// preview and the note of the two steps. Pure functions.

// The acts of Sun that each tape asks for when the record is closed first (RN3 of #210), in the order Sun runs them.
const ACTS_OF_TAPE = [['JOB_STATE', 'INTERRUPT_JOB'], ['PRESENCE', 'LOGOUT_WORKER']]

/**
 * RN22: the mode is the one of the latest preview (`requiresCloseNow`); before the first one, the reading says (`open`).
 * `lastResult` is `{}` when there is none.
 */
export const closeNowModeOf = (intervention, lastResult = {}) => (
  typeof lastResult.requiresCloseNow === 'boolean' ? lastResult.requiresCloseNow : intervention.open === true
)

/**
 * RN23: the preview shown is the one of the current intent and, in close-now mode, says `requiresCloseNow` with its `closeNow`
 * (and no plan hash); in normal mode it carries the `planHash` as before (S41).
 */
export const isVigent = ({ phase, result, resultKey }, intentKey, closeMode) => {
  if (phase !== 'ready' || resultKey !== intentKey) return false
  return closeMode ? result.requiresCloseNow === true && Boolean(result.closeNow) : Boolean(result.planHash)
}

/** RN24: the acts of the vigent preview or, without one, the ones the ticked tapes would need; `tapes` in any order. */
export const actsOf = (vigentResult, tapes) => {
  if (vigentResult && vigentResult.closeNow && Array.isArray(vigentResult.closeNow.acts)) return vigentResult.closeNow.acts
  return ACTS_OF_TAPE.filter(([tape]) => tapes.includes(tape)).map(([, act]) => act)
}

/** RN24 (S42): the acts in the infinitive, translated and joined with «and»; `workerName` is the corrected worker. */
export const actsPhrase = (acts, { t_, workerName }) => acts
  .map((act) => actPhrase(act, { t_, workerName }))
  .reduce((joined, phrase, index) => (index === 0 ? phrase : t_('{{first}} and {{second}}', { first: joined, second: phrase })), '')
